export enum NavigationEntries {
  Settings = '@trustedshops/tswp-core-plugin-settings/settings',
}
